import { Profile as ProfileGQL } from "@onmo/graphql/graphql";

export interface Profile {
  id: string;
  name: string;
  avatar?: string;
  isKid: boolean;
  hasLock: boolean;
  isOwner: boolean;
  hasPin: boolean;
  language?: string;
}

export interface ProfileDraft {
  name: string;
  isKid: boolean;
  hasLock: boolean;
  avatar?: string;
  inventoryId?: string;
  lockPin?: string;
}

export const toProfile = (profile: ProfileGQL): Profile => ({
  id: profile.id,
  name: profile.username,
  avatar: profile.avatar ?? undefined,
  isKid: profile.isKidProfile,
  hasLock: profile.locked,
  isOwner: profile.isMainAccount,
  hasPin: profile.isPinProtected,
  language: profile.language ?? undefined,
});

export const MAX_PROFILES = 5;

// No backend field or action stores it yet; flip once the API exists.
export const IS_CREATION_LOCK_SUPPORTED = false;

export const PIN_LENGTH = 4;

export const VERIFICATION_CODE_LENGTH = 6;

export const PROFILE_NAME_MIN_LENGTH = 3;

export const PROFILE_NAME_MAX_LENGTH = 16;

export const canAddProfile = (profiles: Profile[]) =>
  profiles.length < MAX_PROFILES;

export const isValidProfileName = (name: string) => {
  const length = name.trim().length;
  return length >= PROFILE_NAME_MIN_LENGTH && length <= PROFILE_NAME_MAX_LENGTH;
};
